(function(){
  'use strict';
  const db=()=>window.SM.DB, ui=()=>window.SM.UI, util=()=>window.SM.UTIL;

  // ─── REPORT CATALOGUE ───────────────────────────────────────────
  const REPORTS=[
    {id:'stock_valuation',      cat:'inventory', label:'Stock valuation',          icon:'ti-coins',          desc:'Current stock × cost price. Total capital tied up in stock.'},
    {id:'stock_movements',      cat:'inventory', label:'Stock movement history',   icon:'ti-arrows-up-down', desc:'Every stock in/out per product with dates and references.'},
    {id:'slow_movers',          cat:'inventory', label:'Slow movers / dead stock', icon:'ti-zzz',            desc:'Products with zero or minimal movement over 60/90 days.'},
    {id:'low_stock',            cat:'inventory', label:'Low stock / reorder alert',icon:'ti-alert-circle',   desc:'All products below safety threshold with suggested reorder.'},
    {id:'stock_reconciliation', cat:'inventory', label:'Stock reconciliation',     icon:'ti-checks',         desc:'Opening + received − sold = closing stock per period.'},
    {id:'container_discrepancy',cat:'inventory', label:'Container discrepancy',    icon:'ti-file-diff',      desc:'GRN expected vs received variances per container.'},
    {id:'sales_summary',        cat:'sales',     label:'Sales summary',            icon:'ti-chart-line',     desc:'Total revenue by day, week, month or year.'},
    {id:'sales_by_platform',    cat:'sales',     label:'Sales by platform',        icon:'ti-apps',           desc:'Revenue breakdown across all sales channels.'},
    {id:'sales_by_product',     cat:'sales',     label:'Sales by product',         icon:'ti-box',            desc:'Best and worst selling products by units and revenue.'},
    {id:'sales_by_customer',    cat:'sales',     label:'Sales by customer',        icon:'ti-users',          desc:'Revenue per wholesale customer.'},
    {id:'sales_by_dropship_customer', cat:'dropship', label:'Sales by dropship customer', icon:'ti-truck-delivery', desc:'Revenue and order volume per dropship customer.'},
    {id:'order_fulfilment',     cat:'sales',     label:'Order fulfilment rate',    icon:'ti-circle-check',   desc:'% delivered on time vs delayed vs failed.'},
    {id:'delayed_orders',       cat:'sales',     label:'Delayed orders',           icon:'ti-clock-x',        desc:'All 5+ day delayed orders with courier and follow-up status.'},
    {id:'returns',              cat:'sales',     label:'Returns & refunds',        icon:'ti-arrow-back-up',  desc:'All returned orders with reason, value and resolution.'},
    {id:'platform_comparison',  cat:'sales',     label:'Platform comparison',      icon:'ti-chart-bar',      desc:'Side-by-side revenue comparison across all platforms.'},
    {id:'po_history',           cat:'purchasing',label:'Purchase order history',   icon:'ti-file-invoice',   desc:'All POs with status, supplier, value and delivery performance.'},
    {id:'supplier_performance', cat:'purchasing',label:'Supplier performance',     icon:'ti-building-store', desc:'On-time rate, accuracy, average lead time per supplier.'},
    {id:'container_intelligence',cat:'purchasing',label:'Container intelligence',  icon:'ti-ship',           desc:'Per container: products, qty imported/sold/remaining, margin.'},
    {id:'landed_cost',          cat:'purchasing',label:'Landed cost analysis',     icon:'ti-calculator',     desc:'True cost per unit including freight, duty and other charges.'},
    {id:'purchase_vs_sales',    cat:'purchasing',label:'Purchase vs sales',        icon:'ti-arrows-exchange',desc:'Monthly buying spend vs selling revenue.'},
    {id:'pl_report',            cat:'financial', label:'Profit & Loss',            icon:'ti-report-money',   desc:'Revenue minus COGS minus expenses = net profit. Monthly and annual.'},
    {id:'vat_report',           cat:'financial', label:'VAT return',               icon:'ti-receipt-tax',    desc:'Output minus input VAT = liability. MTD-ready.'},
    {id:'cash_flow',            cat:'financial', label:'Cash flow summary',        icon:'ti-cash',           desc:'Money in vs money out by period.'},
    {id:'payables_ageing',      cat:'financial', label:'Payables ageing',          icon:'ti-clock-dollar',   desc:'What you owe suppliers grouped by age bands.'},
    {id:'receivables_ageing',   cat:'financial', label:'Receivables ageing',       icon:'ti-clock-dollar',   desc:'What customers owe you grouped by age bands.'},
    {id:'customer_statement',   cat:'financial', label:'Customer statement',       icon:'ti-user',           desc:'Full transaction history per wholesale customer.'},
    {id:'supplier_statement',   cat:'financial', label:'Supplier statement',       icon:'ti-building-store', desc:'Full transaction history per supplier.'},
    {id:'expense_breakdown',    cat:'financial', label:'Expense breakdown',        icon:'ti-receipt',        desc:'All expenses by category and period.'},
    {id:'gross_margin_product', cat:'financial', label:'Gross margin by product',  icon:'ti-percentage',     desc:'Sale price minus landed cost per SKU.'},
    {id:'gross_margin_channel', cat:'financial', label:'Gross margin by channel',  icon:'ti-chart-pie',      desc:'Which platform is most profitable.'},
    {id:'claims_log',           cat:'financial', label:'Courier claims log',       icon:'ti-file-alert',     desc:'All claims raised, settled and rejected with amounts.'},
    {id:'courier_performance',  cat:'logistics', label:'Courier performance',      icon:'ti-truck',          desc:'Delivery success rate per courier (couriers only).'},
    {id:'own_truck_performance',cat:'logistics', label:'Own truck performance',    icon:'ti-car',            desc:'Own fleet delivery rate and driver performance.'},
    {id:'manifest_history',     cat:'logistics', label:'Manifest history',         icon:'ti-clipboard-list', desc:'All manifests with driver, vehicle, stops and outcomes.'},
    {id:'courier_cost',         cat:'logistics', label:'Courier cost analysis',    icon:'ti-currency-pound', desc:'Total spend, average cost per parcel, volumetric vs actual.'},
  ];

  const CATS={
    inventory:'Inventory',sales:'Sales & Orders',
    purchasing:'Purchasing & Imports',financial:'Financial',logistics:'Logistics',
    dropship:'Dropship'
  };

  async function load(){
    const content=document.getElementById('ims-reports-content');
    if(!content)return;
    content.innerHTML=`
      <div class="ims__filters" style="margin-bottom:16px">
        <div class="ims__search-wrap" style="max-width:320px"><i class="ti ti-search"></i><input class="ims__input" type="text" id="ims-rep-search" placeholder="Search reports..." oninput="window.IMS_REPORTS.filterReports()"></div>
        <select class="ims__select" id="ims-rep-cat" onchange="window.IMS_REPORTS.filterReports()">
          <option value="">All categories</option>
          ${Object.entries(CATS).map(([k,v])=>`<option value="${k}">${v}</option>`).join('')}
        </select>
      </div>
      <div id="ims-rep-grid">${renderGrid(REPORTS)}</div>`;
  }

  function renderGrid(reports){
    const byCat={};
    reports.forEach(r=>{
      if(!byCat[r.cat])byCat[r.cat]=[];
      byCat[r.cat].push(r);
    });
    return Object.entries(byCat).map(([cat,reps])=>`
      <div style="margin-bottom:20px">
        <h3 style="font-size:13px;font-weight:700;color:var(--ims-text-muted);text-transform:uppercase;letter-spacing:.05em;margin-bottom:10px">${CATS[cat]||cat}</h3>
        <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:10px">
          ${reps.map(r=>`
            <div class="ims__card" style="cursor:pointer;transition:box-shadow .15s" onmouseenter="this.style.boxShadow='var(--ims-shadow-md)'" onmouseleave="this.style.boxShadow=''" onclick="window.IMS_REPORTS.runReport('${r.id}')">
              <div style="display:flex;align-items:flex-start;gap:10px">
                <div style="width:36px;height:36px;border-radius:8px;background:var(--ims-accent-bg);display:flex;align-items:center;justify-content:center;flex-shrink:0">
                  <i class="ti ${r.icon}" style="font-size:18px;color:var(--ims-accent)"></i>
                </div>
                <div>
                  <div style="font-size:13px;font-weight:600;color:var(--ims-text);margin-bottom:3px">${r.label}</div>
                  <div style="font-size:12px;color:var(--ims-text-muted);line-height:1.4">${r.desc}</div>
                </div>
              </div>
            </div>`).join('')}
        </div>
      </div>`).join('');
  }

  function filterReports(){
    const search=document.getElementById('ims-rep-search')?.value?.toLowerCase()||'';
    const cat=document.getElementById('ims-rep-cat')?.value||'';
    const filtered=REPORTS.filter(r=>
      (!cat||r.cat===cat)&&
      (!search||r.label.toLowerCase().includes(search)||r.desc.toLowerCase().includes(search))
    );
    const grid=document.getElementById('ims-rep-grid');
    if(grid)grid.innerHTML=filtered.length?renderGrid(filtered):`<div class="ims__empty"><i class="ti ti-search"></i><p>No reports match your search</p></div>`;
  }

  // ─── DATE RANGE PICKER ──────────────────────────────────────────
  function getDateRange(){
    const from=document.getElementById('ims-rep-from')?.value;
    const to=document.getElementById('ims-rep-to')?.value;
    return{from:from||null,to:to||null};
  }

  function dateRangeHtml(defaultDays=30){
    const to=new Date().toISOString().split('T')[0];
    const from=new Date(Date.now()-defaultDays*86400000).toISOString().split('T')[0];
    return`<div style="display:flex;gap:8px;align-items:center;margin-bottom:14px">
      <label style="font-size:12px;color:var(--ims-text-sec);white-space:nowrap">Date range:</label>
      <input class="ims__input" type="date" id="ims-rep-from" value="${from}" style="width:140px">
      <span style="font-size:12px;color:var(--ims-text-muted)">to</span>
      <input class="ims__input" type="date" id="ims-rep-to" value="${to}" style="width:140px">
      <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_REPORTS.refreshCurrentReport()"><i class="ti ti-refresh"></i> Apply</button>
    </div>`;
  }

  let _currentReportId=null;
  function refreshCurrentReport(){if(_currentReportId)runReport(_currentReportId);}

  // ─── RUN REPORT ─────────────────────────────────────────────────
  async function runReport(id){
    _currentReportId=id;
    const rep=REPORTS.find(r=>r.id===id);
    if(!rep)return;
    ui().openModal(`Report: ${rep.label}`,`<div class="ims__loading"><i class="ti ti-loader-2 ims__spin"></i></div>`,
      `<button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Close</button>
       <button class="ims__btn ims__btn--secondary" id="ims-rep-print-btn" style="display:none" onclick="window.IMS_REPORTS.printCurrentReport()"><i class="ti ti-printer"></i> Print</button>
       <button class="ims__btn ims__btn--secondary" id="ims-rep-csv-btn" style="display:none" onclick="window.IMS_REPORTS.exportCurrentCSV()"><i class="ti ti-download"></i> Export CSV</button>`,'xl');
    await generateReport(id);
  }

  let _reportData=[];
  let _reportHeaders=[];
  let _reportTitle='';

  async function generateReport(id){
    const body=document.getElementById('ims-modal-body');
    if(!body)return;
    const rep=REPORTS.find(r=>r.id===id);
    _reportTitle=rep?.label||id;

    try{
      switch(id){
        case 'stock_valuation':      await rptStockValuation(body);     break;
        case 'stock_movements':      await rptStockMovements(body);     break;
        case 'slow_movers':          await rptSlowMovers(body);         break;
        case 'low_stock':            await rptLowStock(body);           break;
        case 'stock_reconciliation': await rptStockRecon(body);         break;
        case 'container_discrepancy':await rptContainerDiscrepancy(body);break;
        case 'sales_summary':        await rptSalesSummary(body);       break;
        case 'sales_by_platform':    await rptSalesByPlatform(body);    break;
        case 'sales_by_product':     await rptSalesByProduct(body);     break;
        case 'sales_by_customer':    await rptSalesByCustomer(body);    break;
        case 'sales_by_dropship_customer': await rptSalesByDropshipCustomer(body); break;
        case 'order_fulfilment':     await rptOrderFulfilment(body);    break;
        case 'delayed_orders':       await rptDelayedOrders(body);      break;
        case 'returns':              await rptReturns(body);            break;
        case 'platform_comparison':  await rptPlatformComparison(body); break;
        case 'po_history':           await rptPOHistory(body);          break;
        case 'supplier_performance': await rptSupplierPerf(body);       break;
        case 'container_intelligence':await rptContainerIntel(body);    break;
        case 'landed_cost':          await rptLandedCost(body);         break;
        case 'purchase_vs_sales':    await rptPurchaseVsSales(body);    break;
        case 'pl_report':            await rptPL(body);                 break;
        case 'vat_report':           await rptVAT(body);                break;
        case 'cash_flow':            await rptCashFlow(body);           break;
        case 'payables_ageing':      await rptPayablesAgeing(body);     break;
        case 'receivables_ageing':   await rptReceivablesAgeing(body);  break;
        case 'customer_statement':   await rptCustomerStatement(body);  break;
        case 'supplier_statement':   await rptSupplierStatement(body);  break;
        case 'expense_breakdown':    await rptExpenseBreakdown(body);   break;
        case 'gross_margin_product': await rptGrossMarginProduct(body); break;
        case 'gross_margin_channel': await rptGrossMarginChannel(body); break;
        case 'claims_log':           await rptClaimsLog(body);          break;
        case 'price_overrides':      await rptPriceOverrides(body);    break;
        case 'courier_performance':  await rptCourierPerf(body);        break;
        case 'own_truck_performance':await rptOwnTruckPerf(body);       break;
        case 'manifest_history':     await rptManifestHistory(body);    break;
        case 'courier_cost':         await rptCourierCost(body);        break;
        default: body.innerHTML=`<div class="ims__coming-soon"><i class="ti ti-chart-bar"></i><h3>${_reportTitle}</h3><p>This report is available in the next update.</p></div>`;
      }
      document.getElementById('ims-rep-print-btn').style.display='inline-flex';
      document.getElementById('ims-rep-csv-btn').style.display='inline-flex';
    }catch(e){
      body.innerHTML=`<div class="ims__alert ims__alert--danger"><i class="ti ti-alert-circle"></i><span>Failed to generate report: ${e.message}</span></div>`;
    }
  }

  function tbl(headers,rows,emptyMsg='No data'){
    _reportHeaders=headers; _reportData=rows;
    if(!rows.length)return`<div class="ims__empty"><i class="ti ti-inbox"></i><p>${emptyMsg}</p></div>`;
    return`<div class="ims__table-wrap"><table class="ims__table">
      <thead><tr>${headers.map(h=>`<th>${util().sanitize(h)}</th>`).join('')}</tr></thead>
      <tbody>${rows.map(row=>`<tr>${row.map(cell=>`<td>${cell}</td>`).join('')}</tr>`).join('')}</tbody>
    </table></div>`;
  }

  // ─── INVENTORY REPORTS ──────────────────────────────────────────
  async function rptStockValuation(body){
    if(!window.SM.AUTH.canSeeCost()){body.innerHTML=`<div class="ims__coming-soon"><i class="ti ti-lock"></i><h3>Restricted</h3><p>Stock valuation is visible to Admin and Import Manager only.</p></div>`;return;}
    const {data:stock}=await db().select('stock_levels',{select:'quantity,reserved_qty,warehouse_id,product_id,products(name,sku,category),warehouses(name)',noCompanyFilter:true});
    const productIds=[...new Set((stock||[]).map(s=>s.product_id).filter(Boolean))];
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:costPrices}=productIds.length
      ? await client.from('product_prices').select('product_id,price').eq('price_type','cost').is('platform_id',null).in('product_id',productIds)
      : {data:[]};
    const costMap={};
    (costPrices||[]).forEach(p=>{costMap[p.product_id]=p.price||0;});
    const rows=(stock||[]).filter(s=>s.products).map(s=>{
      const cost=costMap[s.product_id]||0;
      const val=(s.quantity||0)*cost;
      return[util().sanitize(s.products?.sku||'—'),util().sanitize(s.products?.name||'—'),util().sanitize(s.products?.category||'—'),util().sanitize(s.warehouses?.name||'—'),s.quantity||0,s.reserved_qty||0,(s.quantity||0)-(s.reserved_qty||0),util().formatCurrency(cost),util().formatCurrency(val)];
    }).sort((a,b)=>parseFloat(b[8].replace(/[£,]/g,''))-parseFloat(a[8].replace(/[£,]/g,'')));
    const total=rows.reduce((s,r)=>s+parseFloat(r[8].replace(/[£,]/g,'')),0);
    body.innerHTML=`<div style="text-align:right;margin-bottom:10px;font-size:15px;font-weight:700">Total stock value: <span style="color:var(--ims-accent)">${util().formatCurrency(total)}</span></div>`+
      tbl(['SKU','Product','Category','Warehouse','On hand','Reserved','Available','Cost price','Stock value'],rows,'No stock records');
  }

  async function rptStockMovements(body){
    body.innerHTML=dateRangeHtml();
    const{from,to}=getDateRange();
    const opts={select:'quantity,movement_type,reference,reason,created_at,products(name,sku),warehouses(name),users(name)',order:{col:'created_at',asc:false},limit:200};
    if(from)opts.gte={created_at:from+'T00:00:00'};
    if(to)opts.lte={created_at:to+'T23:59:59'};
    const {data:movements}=await db().select('stock_movements',opts);
    const rows=(movements||[]).map(m=>[util().formatDate(m.created_at),util().sanitize(m.products?.name||'—'),util().sanitize(m.products?.sku||'—'),util().sanitize(m.movement_type),`<span style="color:${(m.quantity||0)<0?'var(--ims-danger)':'var(--ims-success)'};font-weight:600">${(m.quantity||0)>0?'+':''}${m.quantity||0}</span>`,util().sanitize(m.warehouses?.name||'—'),util().sanitize(m.reference||'—'),util().sanitize(m.reason||'—'),util().sanitize(m.users?.name||'—')]);
    body.innerHTML+=tbl(['Date','Product','SKU','Type','Qty','Warehouse','Reference','Reason','User'],rows);
  }

  async function rptSlowMovers(body){
    const cutoff=new Date(Date.now()-60*86400000).toISOString();
    const {data:products}=await db().select('products',{select:'id,name,sku,category'});
    const {data:recent}=await db().select('stock_movements',{select:'product_id',gte:{created_at:cutoff},eq:{movement_type:'sale'}});
    const recentIds=new Set((recent||[]).map(m=>m.product_id));
    const slow=(products||[]).filter(p=>!recentIds.has(p.id));
    const rows=slow.map(p=>[util().sanitize(p.sku||'—'),util().sanitize(p.name||'—'),util().sanitize(p.category||'—'),'60+ days','No recent sales']);
    body.innerHTML=`<div class="ims__alert ims__alert--warning"><i class="ti ti-info-circle"></i><span>Products with no sales movement in the last 60 days</span></div>`+
      tbl(['SKU','Product','Category','No movement','Note'],rows,'All products have recent sales');
  }

  async function rptLowStock(body){
    const {data:stock}=await db().select('stock_levels',{select:'quantity,reserved_qty,products(name,sku,category,reorder_threshold,reorder_quantity)',order:{col:'quantity'}});
    const rows=(stock||[]).filter(s=>s.products&&(s.quantity||0)<=(s.products?.reorder_threshold||10)).map(s=>[util().sanitize(s.products?.sku||'—'),util().sanitize(s.products?.name||'—'),util().sanitize(s.products?.category||'—'),s.quantity||0,s.products?.reorder_threshold||10,s.products?.reorder_quantity||50,`<span class="ims__pill ims__pill--${(s.quantity||0)<=0?'danger':'warning'}">${(s.quantity||0)<=0?'Out of stock':'Low'}</span>`]);
    body.innerHTML=tbl(['SKU','Product','Category','Stock','Threshold','Reorder qty','Status'],rows,'All stock levels healthy');
  }

  async function rptStockRecon(body){
    body.innerHTML=dateRangeHtml(30);
    const{from,to}=getDateRange();
    const {data:products}=await db().select('products',{select:'id,name,sku'});
    const {data:movements}=await db().select('stock_movements',{select:'product_id,quantity,movement_type',gte:{created_at:(from||'2020-01-01')+'T00:00:00'},lte:{created_at:(to||new Date().toISOString().split('T')[0])+'T23:59:59'}});
    const {data:stock}=await db().select('stock_levels',{select:'quantity,product_id'});
    const rows=(products||[]).map(p=>{
      const mv=movements?.filter(m=>m.product_id===p.id)||[];
      const received=mv.filter(m=>['stock_in','import_received'].includes(m.movement_type)).reduce((s,m)=>s+(m.quantity||0),0);
      const sold=mv.filter(m=>['sale','stock_out'].includes(m.movement_type)).reduce((s,m)=>s+Math.abs(m.quantity||0),0);
      const closing=stock?.find(s=>s.product_id===p.id)?.quantity||0;
      return[util().sanitize(p.sku||'—'),util().sanitize(p.name||'—'),received,sold,closing];
    });
    body.innerHTML+=tbl(['SKU','Product','Received in period','Sold in period','Closing stock'],rows);
  }

  async function rptContainerDiscrepancy(body){
    const {data:grns}=await db().select('grn_records',{select:'grn_number,created_at,imports(container_number),grn_discrepancies(product_name,expected_qty,received_qty,variance,reason)',order:{col:'created_at',asc:false}});
    const rows=[];
    (grns||[]).forEach(grn=>{
      (grn.grn_discrepancies||[]).forEach(d=>{
        rows.push([util().sanitize(grn.imports?.container_number||'—'),util().sanitize(grn.grn_number),util().formatDate(grn.created_at),util().sanitize(d.product_name||'—'),d.expected_qty||0,d.received_qty||0,`<span style="color:${(d.variance||0)<0?'var(--ims-danger)':'var(--ims-success)'};font-weight:600">${(d.variance||0)>0?'+':''}${d.variance||0}</span>`,util().sanitize(d.reason||'—')]);
      });
    });
    body.innerHTML=tbl(['Container','GRN #','Date','Product','Expected','Received','Variance','Reason'],rows,'No discrepancies recorded');
  }

  // ─── SALES REPORTS ──────────────────────────────────────────────
  async function rptSalesSummary(body){
    body.innerHTML=dateRangeHtml();
    const{from,to}=getDateRange();
    const opts={select:'total_value,created_at,status',order:{col:'created_at'}};
    if(from)opts.gte={created_at:from+'T00:00:00'};
    if(to)opts.lte={created_at:to+'T23:59:59'};
    const {data:orders}=await db().select('orders',opts);
    const delivered=(orders||[]).filter(o=>o.status==='delivered');
    const totalRevenue=delivered.reduce((s,o)=>s+(o.total_value||0),0);
    const byMonth={};
    delivered.forEach(o=>{const m=o.created_at?.slice(0,7)||'';byMonth[m]=(byMonth[m]||0)+(o.total_value||0);});
    const rows=Object.entries(byMonth).sort().map(([m,v])=>[m,util().formatCurrency(v)]);
    body.innerHTML+=`<div style="display:flex;gap:16px;margin-bottom:14px">
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Total revenue</div><div class="ims__stat-value ims__stat-value--success" style="font-size:20px">${util().formatCurrency(totalRevenue)}</div></div>
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Orders delivered</div><div class="ims__stat-value" style="font-size:20px">${delivered.length}</div></div>
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Average order value</div><div class="ims__stat-value" style="font-size:20px">${delivered.length?util().formatCurrency(totalRevenue/delivered.length):util().formatCurrency(0)}</div></div>
    </div>`+tbl(['Month','Revenue'],rows);
  }

  async function rptSalesByPlatform(body){
    body.innerHTML=dateRangeHtml();
    const{from,to}=getDateRange();
    const opts={select:'total_value,platforms(name)',neq:{fulfillment_type:'dropship'},order:{col:'total_value',asc:false}};
    if(from)opts.gte={created_at:from+'T00:00:00'};
    if(to)opts.lte={created_at:to+'T23:59:59'};
    const {data:orders}=await db().select('orders',opts);
    const byPlatform={};
    (orders||[]).forEach(o=>{const p=o.platforms?.name||'Unknown';byPlatform[p]=(byPlatform[p]||{count:0,revenue:0});byPlatform[p].count++;byPlatform[p].revenue+=(o.total_value||0);});
    const rows=Object.entries(byPlatform).sort((a,b)=>b[1].revenue-a[1].revenue).map(([p,v])=>[util().sanitize(p),v.count,util().formatCurrency(v.revenue),util().formatCurrency(v.count?v.revenue/v.count:0)]);
    body.innerHTML+=tbl(['Platform','Orders','Revenue','Avg order value'],rows);
  }

  async function rptSalesByProduct(body){
    body.innerHTML=dateRangeHtml();
    const{from,to}=getDateRange();
    // Get company orders first, then their items
    const opts={select:'id,created_at',order:{col:'created_at'}};
    if(from)opts.gte={created_at:from+'T00:00:00'};
    if(to)opts.lte={created_at:to+'T23:59:59'};
    const {data:orders}=await db().select('orders',opts);
    const orderIds=(orders||[]).map(o=>o.id);
    if(!orderIds.length){body.innerHTML+=tbl(['SKU','Product','Units sold','Revenue','Avg unit price'],[]);return;}
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:items}=await client.from('order_items').select('quantity,unit_price,total_price,product_name,sku').in('order_id',orderIds);
    const byProduct={};
    (items||[]).forEach(i=>{const k=i.sku||i.product_name||'—';if(!byProduct[k])byProduct[k]={name:i.product_name||i.sku,sku:i.sku,units:0,revenue:0};byProduct[k].units+=(i.quantity||0);byProduct[k].revenue+=(i.total_price||0);});
    const rows=Object.values(byProduct).sort((a,b)=>b.revenue-a.revenue).map(p=>[util().sanitize(p.sku||'—'),util().sanitize(p.name||'—'),p.units,util().formatCurrency(p.revenue),util().formatCurrency(p.units?p.revenue/p.units:0)]);
    body.innerHTML+=tbl(['SKU','Product','Units sold','Revenue','Avg unit price'],rows);
  }

  async function rptSalesByCustomer(body){
    body.innerHTML=dateRangeHtml();
    const {data:orders}=await db().select('orders',{select:'customer_name,total_value,order_type',eq:{order_type:'wholesale'},order:{col:'total_value',asc:false}});
    const byCust={};
    (orders||[]).forEach(o=>{const k=o.customer_name||'Unknown';if(!byCust[k])byCust[k]={orders:0,revenue:0};byCust[k].orders++;byCust[k].revenue+=(o.total_value||0);});
    const rows=Object.entries(byCust).sort((a,b)=>b[1].revenue-a[1].revenue).map(([name,v])=>[util().sanitize(name),v.orders,util().formatCurrency(v.revenue),util().formatCurrency(v.orders?v.revenue/v.orders:0)]);
    body.innerHTML+=tbl(['Customer','Orders','Total spend','Avg order value'],rows);
  }

  async function rptSalesByDropshipCustomer(body){
    body.innerHTML=dateRangeHtml();
    const{from,to}=getDateRange();
    const opts={select:'total_value,dropship_customers(business_name)',eq:{fulfillment_type:'dropship'},order:{col:'total_value',asc:false}};
    if(from)opts.gte={created_at:from+'T00:00:00'};
    if(to)opts.lte={created_at:to+'T23:59:59'};
    const {data:orders}=await db().select('orders',opts);
    const byCust={};
    (orders||[]).forEach(o=>{const c=o.dropship_customers?.business_name||'Unknown';byCust[c]=(byCust[c]||{count:0,revenue:0});byCust[c].count++;byCust[c].revenue+=(o.total_value||0);});
    const total=Object.values(byCust).reduce((s,v)=>s+v.revenue,0);
    const rows=Object.entries(byCust).sort((a,b)=>b[1].revenue-a[1].revenue).map(([c,v])=>[util().sanitize(c),v.count,util().formatCurrency(v.revenue),total>0?((v.revenue/total)*100).toFixed(1)+'%':'0%',util().formatCurrency(v.count?v.revenue/v.count:0)]);
    body.innerHTML+=tbl(['Dropship customer','Orders','Revenue','% of total','Avg order value'],rows,'No dropship orders in this period');
  }

  async function rptOrderFulfilment(body){
    body.innerHTML=dateRangeHtml();
    const{from,to}=getDateRange();
    const opts={select:'status,dispatched_at'};
    if(from)opts.gte={created_at:from+'T00:00:00'};
    if(to)opts.lte={created_at:to+'T23:59:59'};
    const {data:orders}=await db().select('orders',opts);
    const total=(orders||[]).length;
    const delivered=(orders||[]).filter(o=>o.status==='delivered').length;
    const delayed=(orders||[]).filter(o=>util().isDelayed(o)).length;
    const failed=(orders||[]).filter(o=>o.status==='failed').length;
    const lost=(orders||[]).filter(o=>o.status==='lost').length;
    const rate=total?((delivered/total)*100).toFixed(1):0;
    body.innerHTML+=`<div style="display:grid;grid-template-columns:repeat(5,1fr);gap:8px;margin-bottom:14px">
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Total orders</div><div class="ims__stat-value" style="font-size:20px">${total}</div></div>
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Delivered</div><div class="ims__stat-value ims__stat-value--success" style="font-size:20px">${delivered}</div></div>
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Delayed</div><div class="ims__stat-value ims__stat-value--${delayed>0?'warning':''}" style="font-size:20px">${delayed}</div></div>
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Failed</div><div class="ims__stat-value ims__stat-value--${failed>0?'danger':''}" style="font-size:20px">${failed}</div></div>
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Fulfilment rate</div><div class="ims__stat-value ims__stat-value--${rate>=95?'success':rate>=80?'warning':'danger'}" style="font-size:20px">${rate}%</div></div>
    </div>`;
  }

  async function rptDelayedOrders(body){
    const {data:orders}=await db().select('orders',{select:'order_number,customer_name,postcode,dispatched_at,status,platforms(name)',eq:{status:'dispatched'}});
    const delayed=(orders||[]).filter(o=>util().isDelayed(o));
    const rows=delayed.map(o=>[util().sanitize(o.order_number),util().sanitize(o.customer_name||'—'),util().sanitize(o.platforms?.name||'—'),util().sanitize(o.postcode||'—'),util().formatDate(o.dispatched_at),`${util().daysSince(o.dispatched_at)} days`]);
    body.innerHTML=tbl(['Order #','Customer','Platform','Postcode','Dispatched','Days delayed'],rows,'No delayed orders');
  }

  async function rptReturns(body){
    const {data:orders}=await db().select('orders',{select:'order_number,customer_name,total_value,status,created_at',in:{status:['cancelled','failed']}});
    const rows=(orders||[]).map(o=>[util().sanitize(o.order_number),util().sanitize(o.customer_name||'—'),util().formatCurrency(o.total_value),o.status,util().formatDate(o.created_at)]);
    body.innerHTML=tbl(['Order #','Customer','Value','Status','Date'],rows,'No returns');
  }

  async function rptPlatformComparison(body){
    body.innerHTML=dateRangeHtml();
    const {data:orders}=await db().select('orders',{select:'total_value,platforms(name)',neq:{status:'cancelled',fulfillment_type:'dropship'}});
    const map={};
    (orders||[]).forEach(o=>{const p=o.platforms?.name||'Unknown';if(!map[p])map[p]={orders:0,revenue:0};map[p].orders++;map[p].revenue+=(o.total_value||0);});
    const total=Object.values(map).reduce((s,v)=>s+v.revenue,0);
    const rows=Object.entries(map).sort((a,b)=>b[1].revenue-a[1].revenue).map(([p,v])=>[util().sanitize(p),v.orders,util().formatCurrency(v.revenue),total>0?((v.revenue/total)*100).toFixed(1)+'%':'0%',util().formatCurrency(v.orders?v.revenue/v.orders:0)]);
    body.innerHTML+=tbl(['Platform','Orders','Revenue','% of total','Avg order'],rows);
  }

  // ─── PURCHASING REPORTS ─────────────────────────────────────────
  async function rptPOHistory(body){
    const {data:pos}=await db().select('purchase_orders',{select:'po_number,status,total_value,currency,expected_delivery,created_at,suppliers(name)',order:{col:'created_at',asc:false}});
    const rows=(pos||[]).map(p=>[util().sanitize(p.po_number),util().sanitize(p.suppliers?.name||'—'),p.expected_delivery?util().formatDate(p.expected_delivery):'—',util().formatDate(p.created_at),util().formatCurrency(p.total_value),util().pill(p.status)]);
    body.innerHTML=tbl(['PO #','Supplier','Expected','Created','Value','Status'],rows);
  }

  async function rptSupplierPerf(body){
    const {data:pos}=await db().select('purchase_orders',{select:'status,expected_delivery,suppliers(name)',neq:{status:'draft'}});
    const map={};
    (pos||[]).forEach(p=>{const s=p.suppliers?.name||'Unknown';if(!map[s])map[s]={total:0,completed:0,onTime:0,late:0};map[s].total++;if(p.status==='completed'){map[s].completed++;if(p.expected_delivery&&new Date(p.expected_delivery)>=new Date())map[s].onTime++;else map[s].late++;}});
    const rows=Object.entries(map).map(([s,v])=>[util().sanitize(s),v.total,v.completed,v.onTime,v.late,v.completed?((v.onTime/v.completed)*100).toFixed(0)+'%':'—']);
    body.innerHTML=tbl(['Supplier','Total POs','Completed','On time','Late','On-time rate'],rows);
  }

  async function rptContainerIntel(body){
    const {data:imports}=await db().select('imports',{select:'container_number,landed_cost,suppliers(name),import_items(qty_expected,qty_received,qty_remaining)',order:{col:'created_at',asc:false}});
    const rows=(imports||[]).map(imp=>{
      const received=(imp.import_items||[]).reduce((s,i)=>s+(i.qty_received||0),0);
      const remaining=(imp.import_items||[]).reduce((s,i)=>s+(i.qty_remaining||0),0);
      return[util().sanitize(imp.container_number||'—'),util().sanitize(imp.suppliers?.name||'—'),received,received-remaining,remaining,util().formatCurrency(imp.landed_cost)];
    });
    body.innerHTML=tbl(['Container','Supplier','Received','Sold','Remaining','Landed cost'],rows);
  }

  async function rptLandedCost(body){
    if(!window.SM.AUTH.canSeeCost()){body.innerHTML=`<div class="ims__coming-soon"><i class="ti ti-lock"></i><h3>Restricted</h3><p>Landed cost analysis is visible to Admin and Import Manager only.</p></div>`;return;}
    const {data:imports}=await db().select('imports',{select:'container_number,landed_cost,suppliers(name),import_items(qty_received,products(name,sku,cost_price))'});
    const rows=[];
    (imports||[]).forEach(imp=>{
      const items=imp.import_items?.filter(i=>(i.qty_received||0)>0&&i.products)||[];
      const totalUnits=items.reduce((s,i)=>s+(i.qty_received||0),0);
      const costPerUnit=totalUnits>0?(imp.landed_cost||0)/totalUnits:0;
      items.forEach(item=>{
        const trueCost=(item.products?.cost_price||0)+costPerUnit;
        rows.push([util().sanitize(imp.container_number||'—'),util().sanitize(item.products?.sku||'—'),util().sanitize(item.products?.name||'—'),item.qty_received||0,util().formatCurrency(item.products?.cost_price||0),util().formatCurrency(costPerUnit),util().formatCurrency(trueCost)]);
      });
    });
    body.innerHTML=tbl(['Container','SKU','Product','Qty','Product cost','Freight/unit','True landed cost'],rows);
  }

  async function rptPurchaseVsSales(body){
    const {data:pos}=await db().select('purchase_orders',{select:'total_value,created_at',neq:{status:'draft'},order:{col:'created_at'}});
    const {data:orders}=await db().select('orders',{select:'total_value,created_at',eq:{status:'delivered'},order:{col:'created_at'}});
    const months={};
    (pos||[]).forEach(p=>{const m=p.created_at?.slice(0,7)||'';if(!months[m])months[m]={purchases:0,sales:0};months[m].purchases+=(p.total_value||0);});
    (orders||[]).forEach(o=>{const m=o.created_at?.slice(0,7)||'';if(!months[m])months[m]={purchases:0,sales:0};months[m].sales+=(o.total_value||0);});
    const rows=Object.entries(months).sort().map(([m,v])=>[m,util().formatCurrency(v.purchases),util().formatCurrency(v.sales),util().formatCurrency(v.sales-v.purchases)]);
    body.innerHTML=tbl(['Month','Purchases','Sales','Net'],rows);
  }

  // ─── FINANCIAL REPORTS ──────────────────────────────────────────
  async function rptPL(body){
    if(!window.SM.AUTH.hasRole('super_admin','admin','accounts_staff')){body.innerHTML=`<div class="ims__coming-soon"><i class="ti ti-lock"></i><h3>Restricted</h3><p>P&L report is visible to Admin and Accounts Staff only.</p></div>`;return;}
    body.innerHTML=dateRangeHtml(365);
    const{from,to}=getDateRange();
    const opts={};
    if(from)opts.gte={date:from};
    if(to)opts.lte={date:to};
    const {data:txs}=await db().select('transactions',{...opts,order:{col:'date'}});
    const income=(txs||[]).filter(t=>t.type==='income').reduce((s,t)=>s+(t.amount||0),0);
    const cogs=(txs||[]).filter(t=>t.type==='expense'&&t.category==='Cost of goods sold').reduce((s,t)=>s+(t.amount||0),0);
    const expenses=(txs||[]).filter(t=>t.type==='expense'&&t.category!=='Cost of goods sold').reduce((s,t)=>s+(t.amount||0),0);
    const gross=income-cogs;
    const net=gross-expenses;
    const expByCat=(txs||[]).filter(t=>t.type==='expense'&&t.category!=='Cost of goods sold').reduce((acc,t)=>{acc[t.category]=(acc[t.category]||0)+(t.amount||0);return acc;},{});
    body.innerHTML+=`<table class="ims__table"><tbody>
      <tr><td style="padding-left:0"><strong>Sales revenue</strong></td><td style="text-align:right;font-weight:700;color:var(--ims-success)">${util().formatCurrency(income)}</td></tr>
      <tr><td style="padding-left:20px;color:var(--ims-text-sec)">Less: Cost of goods sold</td><td style="text-align:right;color:var(--ims-text-sec)">(${util().formatCurrency(cogs)})</td></tr>
      <tr style="border-top:2px solid var(--ims-border)"><td><strong>Gross profit</strong></td><td style="text-align:right;font-weight:700;color:${gross>=0?'var(--ims-success)':'var(--ims-danger)'}">${util().formatCurrency(gross)}</td></tr>
      <tr><td colspan="2" style="padding:6px 0 2px;font-size:12px;font-weight:600;color:var(--ims-text-muted)">OPERATING EXPENSES</td></tr>
      ${Object.entries(expByCat).map(([cat,amt])=>`<tr><td style="padding-left:20px;color:var(--ims-text-sec)">${util().sanitize(cat)}</td><td style="text-align:right;color:var(--ims-text-sec)">(${util().formatCurrency(amt)})</td></tr>`).join('')}
      <tr style="border-top:1px solid var(--ims-border)"><td style="padding-left:20px"><strong>Total expenses</strong></td><td style="text-align:right;font-weight:600">(${util().formatCurrency(expenses)})</td></tr>
      <tr style="border-top:2px solid var(--ims-border);font-size:15px"><td><strong>Net profit / (loss)</strong></td><td style="text-align:right;font-weight:700;color:${net>=0?'var(--ims-success)':'var(--ims-danger)'}">${util().formatCurrency(net)}</td></tr>
    </tbody></table>`;
  }

  async function rptVAT(body){
    body.innerHTML=dateRangeHtml(90);
    const{from,to}=getDateRange();
    const opts={};
    if(from)opts.gte={date:from};
    if(to)opts.lte={date:to};
    const {data:txs}=await db().select('transactions',{...opts});
    const outputVAT=(txs||[]).filter(t=>t.type==='income').reduce((s,t)=>s+(t.vat_amount||0),0);
    const inputVAT=(txs||[]).filter(t=>t.type==='expense').reduce((s,t)=>s+(t.vat_amount||0),0);
    const net=outputVAT-inputVAT;
    body.innerHTML+=`<table class="ims__table"><tbody>
      <tr><td>Box 1: VAT due on sales</td><td style="text-align:right;font-weight:600">${util().formatCurrency(outputVAT)}</td></tr>
      <tr><td>Box 2: VAT due on acquisitions</td><td style="text-align:right">£0.00</td></tr>
      <tr><td>Box 3: Total VAT due</td><td style="text-align:right;font-weight:600">${util().formatCurrency(outputVAT)}</td></tr>
      <tr><td>Box 4: VAT reclaimed</td><td style="text-align:right;font-weight:600">${util().formatCurrency(inputVAT)}</td></tr>
      <tr style="border-top:2px solid var(--ims-border)"><td><strong>Box 5: Net VAT</strong></td><td style="text-align:right;font-weight:700;color:${net>0?'var(--ims-danger)':'var(--ims-success)'}">${util().formatCurrency(Math.abs(net))} ${net>0?'(payable)':'(refund)'}</td></tr>
    </tbody></table>`;
  }

  async function rptCashFlow(body){
    body.innerHTML=dateRangeHtml();
    const{from,to}=getDateRange();
    const opts={order:{col:'date'}};
    if(from)opts.gte={date:from};
    if(to)opts.lte={date:to};
    const {data:txs}=await db().select('transactions',{...opts});
    const byWeek={};
    (txs||[]).forEach(t=>{
      const d=new Date(t.date);
      const wk=`${d.getFullYear()}-W${Math.ceil((d.getDate()+new Date(d.getFullYear(),d.getMonth(),1).getDay())/7)}`;
      if(!byWeek[wk])byWeek[wk]={in:0,out:0};
      if(t.type==='income')byWeek[wk].in+=(t.amount||0);
      else byWeek[wk].out+=(t.amount||0);
    });
    const rows=Object.entries(byWeek).sort().map(([w,v])=>[w,util().formatCurrency(v.in),util().formatCurrency(v.out),util().formatCurrency(v.in-v.out)]);
    body.innerHTML+=tbl(['Week','Money in','Money out','Net'],rows);
  }

  async function rptPayablesAgeing(body){
    const {data:payables}=await db().select('accounts_payable',{select:'amount,paid_amount,created_at,suppliers(name)',neq:{status:'paid'}});
    const rows=(payables||[]).map(p=>{
      const outstanding=(p.amount||0)-(p.paid_amount||0);
      const days=util().daysSince(p.created_at);
      const band=days<=30?'0–30d':days<=60?'31–60d':days<=90?'61–90d':'90d+';
      return[util().sanitize(p.suppliers?.name||'—'),util().formatDate(p.created_at),util().formatCurrency(outstanding),days+'d',`<span class="ims__pill ims__pill--${days>60?'danger':days>30?'warning':'neutral'}">${band}</span>`];
    }).sort((a,b)=>parseInt(b[3])-parseInt(a[3]));
    body.innerHTML=tbl(['Supplier','Created','Outstanding','Age','Band'],rows,'No outstanding payables');
  }

  async function rptReceivablesAgeing(body){
    const {data:receivables}=await db().select('accounts_receivable',{select:'amount,paid_amount,created_at,customers(business_name)',neq:{status:'paid'}});
    const rows=(receivables||[]).map(r=>{
      const outstanding=(r.amount||0)-(r.paid_amount||0);
      const days=util().daysSince(r.created_at);
      const band=days<=30?'0–30d':days<=60?'31–60d':days<=90?'61–90d':'90d+';
      return[util().sanitize(r.customers?.business_name||'—'),util().formatDate(r.created_at),util().formatCurrency(outstanding),days+'d',`<span class="ims__pill ims__pill--${days>60?'danger':days>30?'warning':'neutral'}">${band}</span>`];
    }).sort((a,b)=>parseInt(b[3])-parseInt(a[3]));
    body.innerHTML=tbl(['Customer','Created','Outstanding','Age','Band'],rows,'No outstanding receivables');
  }

  async function rptCustomerStatement(body){
    const {data:customers}=await db().select('customers',{order:{col:'business_name'}});
    if(!customers?.length){body.innerHTML='<div class="ims__empty"><i class="ti ti-users"></i><p>No customers found</p></div>';return;}
    const opts=(customers||[]).map(c=>`<option value="${c.id}">${util().sanitize(c.business_name)}</option>`).join('');
    body.innerHTML=`
      <div class="ims__form-group" style="margin-bottom:14px">
        <label class="ims__label">Select customer</label>
        <select class="ims__select" id="ims-stmt-cust" onchange="window.IMS_REPORTS.loadCustomerStatement()"><option value="">Choose customer...</option>${opts}</select>
      </div>
      <div id="ims-stmt-body"></div>`;
  }

  async function loadCustomerStatement(){
    const id=document.getElementById('ims-stmt-cust')?.value;
    const body=document.getElementById('ims-stmt-body');
    if(!id||!body)return;
    const {data:orders}=await db().select('orders',{select:'order_number,total_value,status,created_at',eq:{customer_id:id},order:{col:'created_at',asc:false}});
    const {data:receivables}=await db().select('accounts_receivable',{select:'amount,paid_amount,created_at,status',eq:{customer_id:id},order:{col:'created_at',asc:false},noCompanyFilter:true});
    const totalSpend=(orders||[]).reduce((s,o)=>s+(o.total_value||0),0);
    const outstanding=(receivables||[]).filter(r=>r.status!=='paid').reduce((s,r)=>s+((r.amount||0)-(r.paid_amount||0)),0);
    body.innerHTML=`<div style="display:flex;gap:12px;margin-bottom:14px">
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Total orders</div><div class="ims__stat-value" style="font-size:18px">${(orders||[]).length}</div></div>
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Total spend</div><div class="ims__stat-value ims__stat-value--success" style="font-size:18px">${util().formatCurrency(totalSpend)}</div></div>
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Outstanding</div><div class="ims__stat-value ims__stat-value--${outstanding>0?'danger':''}" style="font-size:18px">${util().formatCurrency(outstanding)}</div></div>
    </div>`+tbl(['Order #','Value','Status','Date'],(orders||[]).map(o=>[util().sanitize(o.order_number),util().formatCurrency(o.total_value),util().pill(o.status),util().formatDate(o.created_at)]));
  }

  async function rptSupplierStatement(body){
    const {data:suppliers}=await db().select('suppliers',{order:{col:'name'}});
    const opts=(suppliers||[]).map(s=>`<option value="${s.id}">${util().sanitize(s.name)}</option>`).join('');
    body.innerHTML=`
      <div class="ims__form-group" style="margin-bottom:14px">
        <label class="ims__label">Select supplier</label>
        <select class="ims__select" id="ims-sup-stmt" onchange="window.IMS_REPORTS.loadSupplierStatement()"><option value="">Choose supplier...</option>${opts}</select>
      </div><div id="ims-sup-stmt-body"></div>`;
  }

  async function loadSupplierStatement(){
    const id=document.getElementById('ims-sup-stmt')?.value;
    const body=document.getElementById('ims-sup-stmt-body');
    if(!id||!body)return;
    const {data:pos}=await db().select('purchase_orders',{select:'po_number,total_value,status,created_at',eq:{supplier_id:id},order:{col:'created_at',asc:false}});
    const {data:payables}=await db().select('accounts_payable',{select:'amount,paid_amount,status',eq:{supplier_id:id},noCompanyFilter:true});
    const totalOrdered=(pos||[]).reduce((s,p)=>s+(p.total_value||0),0);
    const outstanding=(payables||[]).filter(p=>p.status!=='paid').reduce((s,p)=>s+((p.amount||0)-(p.paid_amount||0)),0);
    body.innerHTML=`<div style="display:flex;gap:12px;margin-bottom:14px">
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Total POs</div><div class="ims__stat-value" style="font-size:18px">${(pos||[]).length}</div></div>
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Total ordered</div><div class="ims__stat-value" style="font-size:18px">${util().formatCurrency(totalOrdered)}</div></div>
      <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Outstanding</div><div class="ims__stat-value ims__stat-value--${outstanding>0?'warning':''}" style="font-size:18px">${util().formatCurrency(outstanding)}</div></div>
    </div>`+tbl(['PO #','Value','Status','Date'],(pos||[]).map(p=>[util().sanitize(p.po_number),util().formatCurrency(p.total_value),util().pill(p.status),util().formatDate(p.created_at)]));
  }

  async function rptExpenseBreakdown(body){
    body.innerHTML=dateRangeHtml();
    const{from,to}=getDateRange();
    const opts={eq:{type:'expense'},order:{col:'date',asc:false}};
    if(from)opts.gte={date:from};
    if(to)opts.lte={date:to};
    const {data:txs}=await db().select('transactions',{...opts});
    const byCat=(txs||[]).reduce((acc,t)=>{acc[t.category]=(acc[t.category]||0)+(t.amount||0);return acc;},{});
    const total=Object.values(byCat).reduce((s,v)=>s+v,0);
    const rows=Object.entries(byCat).sort((a,b)=>b[1]-a[1]).map(([cat,amt])=>[util().sanitize(cat),util().formatCurrency(amt),total?((amt/total)*100).toFixed(1)+'%':'0%']);
    body.innerHTML+=tbl(['Category','Amount','% of total'],rows,'No expense records');
  }

  async function rptGrossMarginProduct(body){
    if(!window.SM.AUTH.canSeeCost()){body.innerHTML=`<div class="ims__coming-soon"><i class="ti ti-lock"></i><h3>Restricted</h3><p>Gross margin reports are visible to Admin and Import Manager only.</p></div>`;return;}
    body.innerHTML=dateRangeHtml();
    const{from,to}=getDateRange();
    const opts={select:'id'};
    if(from)opts.gte={created_at:from+'T00:00:00'};
    if(to)opts.lte={created_at:to+'T23:59:59'};
    const {data:orders}=await db().select('orders',opts);
    const orderIds=(orders||[]).map(o=>o.id);
    if(!orderIds.length){body.innerHTML+=tbl(['SKU','Product','Units','Revenue','Cost','Gross margin','Margin %'],[]);return;}
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:items}=await client.from('order_items').select('quantity,total_price,cost_price,product_name,sku').in('order_id',orderIds);
    const byProd={};
    (items||[]).forEach(i=>{const k=i.sku||i.product_name||'—';if(!byProd[k])byProd[k]={name:i.product_name||i.sku,sku:i.sku,units:0,revenue:0,cost:0};byProd[k].units+=(i.quantity||0);byProd[k].revenue+=(i.total_price||0);byProd[k].cost+=(i.cost_price||0)*(i.quantity||0);});
    const rows=Object.values(byProd).sort((a,b)=>b.revenue-a.revenue).map(p=>{const margin=p.revenue-p.cost;const pct=p.revenue?((margin/p.revenue)*100).toFixed(1):0;return[util().sanitize(p.sku||'—'),util().sanitize(p.name||'—'),p.units,util().formatCurrency(p.revenue),util().formatCurrency(p.cost),util().formatCurrency(margin),pct+'%'];});
    body.innerHTML+=tbl(['SKU','Product','Units','Revenue','Cost','Gross margin','Margin %'],rows);
  }

  async function rptGrossMarginChannel(body){
    if(!window.SM.AUTH.canSeeCost()){body.innerHTML=`<div class="ims__coming-soon"><i class="ti ti-lock"></i><h3>Restricted</h3><p>Gross margin reports are visible to Admin and Import Manager only.</p></div>`;return;}
    body.innerHTML=dateRangeHtml();
    const{from,to}=getDateRange();
    const opts={select:'id,total_value,platforms(name)'};
    if(from)opts.gte={created_at:from+'T00:00:00'};
    if(to)opts.lte={created_at:to+'T23:59:59'};
    const {data:orders}=await db().select('orders',opts);
    const orderIds=(orders||[]).map(o=>o.id);
    if(!orderIds.length){body.innerHTML+=tbl(['Platform','Revenue','Cost','Gross margin','Margin %'],[]);return;}
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:items}=await client.from('order_items').select('order_id,cost_price,quantity').in('order_id',orderIds);
    const itemsByOrder={};
    (items||[]).forEach(i=>{if(!itemsByOrder[i.order_id])itemsByOrder[i.order_id]=[];itemsByOrder[i.order_id].push(i);});
    const byPlat={};
    (orders||[]).forEach(o=>{const p=o.platforms?.name||'Unknown';if(!byPlat[p])byPlat[p]={revenue:0,cost:0};byPlat[p].revenue+=(o.total_value||0);(itemsByOrder[o.id]||[]).forEach(i=>{byPlat[p].cost+=((i.cost_price||0)*(i.quantity||0));});});
    const rows=Object.entries(byPlat).sort((a,b)=>b[1].revenue-a[1].revenue).map(([p,v])=>{const m=v.revenue-v.cost;const pct=v.revenue?((m/v.revenue)*100).toFixed(1):0;return[util().sanitize(p),util().formatCurrency(v.revenue),util().formatCurrency(v.cost),util().formatCurrency(m),pct+'%'];});
    body.innerHTML+=tbl(['Platform','Revenue','Cost','Gross margin','Margin %'],rows);
  }

  async function rptClaimsLog(body){
    const {data:claims}=await db().select('claims',{select:'claim_reference,items_value,status,raised_at,settled_amount,orders(order_number),couriers(name)',order:{col:'raised_at',asc:false}});
    const rows=(claims||[]).map(c=>[util().sanitize(c.claim_reference||c.id?.slice(0,8)||'—'),util().sanitize(c.orders?.order_number||'—'),util().sanitize(c.couriers?.name||'—'),util().formatCurrency(c.items_value),util().formatDate(c.raised_at),util().pill(c.status),c.settled_amount?util().formatCurrency(c.settled_amount):'—']);
    body.innerHTML=tbl(['Claim ref','Order #','Courier','Claim value','Raised','Status','Settled'],rows,'No claims');
  }

  // ─── LOGISTICS REPORTS ──────────────────────────────────────────
  async function rptCourierPerf(body){
    const {data:shipments}=await db().select('shipments',{select:'status,couriers(name)',eq:{ship_mode:'courier'}});
    const byCourier={};
    (shipments||[]).forEach(s=>{const c=s.couriers?.name||'Unknown';if(!byCourier[c])byCourier[c]={total:0,delivered:0,failed:0};byCourier[c].total++;if(s.status==='delivered')byCourier[c].delivered++;if(s.status==='failed')byCourier[c].failed++;});
    const rows=Object.entries(byCourier).sort((a,b)=>b[1].total-a[1].total).map(([c,v])=>{const rate=v.total?((v.delivered/v.total)*100).toFixed(1):0;return[util().sanitize(c),v.total,v.delivered,v.failed,`<span style="color:${rate>=95?'var(--ims-success)':rate>=80?'var(--ims-warning)':'var(--ims-danger)'};font-weight:600">${rate}%</span>`];});
    body.innerHTML=`<div class="ims__alert ims__alert--info"><i class="ti ti-info-circle"></i><span>Courier deliveries only — own truck performance is in a separate report.</span></div>`+
      tbl(['Courier','Total shipments','Delivered','Failed','Success rate'],rows,'No courier shipments');
  }

  async function rptOwnTruckPerf(body){
    const {data:manifests}=await db().select('manifests',{select:'status,manifest_number,drivers(name),manifest_items(delivery_status)',order:{col:'created_at',asc:false}});
    const rows=(manifests||[]).map(m=>{
      const items=m.manifest_items||[];
      const delivered=items.filter(i=>i.delivery_status==='delivered').length;
      const failed=items.filter(i=>i.delivery_status==='failed').length;
      const total=items.length;
      const rate=total?((delivered/total)*100).toFixed(0):0;
      return[util().sanitize(m.manifest_number),util().sanitize(m.drivers?.name||'—'),total,delivered,failed,rate+'%',util().pill(m.status)];
    });
    body.innerHTML=tbl(['Manifest','Driver','Stops','Delivered','Failed','Success rate','Status'],rows,'No own truck manifests');
  }

  async function rptManifestHistory(body){
    const {data:manifests}=await db().select('manifests',{select:'manifest_number,status,dispatched_at,drivers(name),vehicles(registration),manifest_items(delivery_status)',order:{col:'dispatched_at',asc:false}});
    const rows=(manifests||[]).map(m=>{const items=m.manifest_items||[];const d=items.filter(i=>i.delivery_status==='delivered').length;return[util().sanitize(m.manifest_number),util().sanitize(m.drivers?.name||'—'),util().sanitize(m.vehicles?.registration||'—'),m.dispatched_at?util().formatDate(m.dispatched_at):'—',items.length,d,util().pill(m.status)];});
    body.innerHTML=tbl(['Manifest','Driver','Vehicle','Date','Stops','Delivered','Status'],rows);
  }

  async function rptCourierCost(body){
    const {data:shipments}=await db().select('shipments',{select:'charge_amount,weight_actual,weight_vol,weight_charged,couriers(name)',eq:{ship_mode:'courier'}});
    const byCourier={};
    (shipments||[]).forEach(s=>{const c=s.couriers?.name||'Unknown';if(!byCourier[c])byCourier[c]={count:0,total:0,vol:0,actual:0};byCourier[c].count++;byCourier[c].total+=(s.charge_amount||0);if((s.weight_vol||0)>(s.weight_actual||0))byCourier[c].vol++;else byCourier[c].actual++;});
    const rows=Object.entries(byCourier).sort((a,b)=>b[1].total-a[1].total).map(([c,v])=>[util().sanitize(c),v.count,util().formatCurrency(v.total),util().formatCurrency(v.count?v.total/v.count:0),v.vol+' vol / '+v.actual+' actual']);
    body.innerHTML=tbl(['Courier','Shipments','Total spend','Avg per parcel','Charge basis'],rows,'No courier cost data');
  }

  async function rptPriceOverrides(body){
    if(!window.SM.AUTH.isAdmin()&&!window.SM.AUTH.canSeeCost()){
      body.innerHTML=`<div class="ims__coming-soon"><i class="ti ti-lock"></i><h3>Restricted</h3><p>Price override log is visible to Admin only.</p></div>`;return;
    }
    body.innerHTML=dateRangeHtml();
    const{from,to}=getDateRange();
    const opts={select:'id',order:{col:'created_at',asc:false}};
    if(from)opts.gte={created_at:from+'T00:00:00'};
    if(to)opts.lte={created_at:to+'T23:59:59'};
    opts.eq={has_price_override:true};
    const {data:orders}=await db().select('orders',opts);
    const orderIds=(orders||[]).map(o=>o.id);
    if(!orderIds.length){
      body.innerHTML+=`<div class="ims__alert ims__alert--success" style="margin-top:14px"><i class="ti ti-check"></i><span>No price overrides in this period — all orders used standard catalogue prices.</span></div>`;
      return;
    }
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:items}=await client.from('order_items')
      .select('order_id,product_name,sku,quantity,unit_price,standard_price,override_pct,override_reason,price_overridden')
      .in('order_id',orderIds)
      .eq('price_overridden',true);

    // Get order details
    const {data:orderDetails}=await db().select('orders',{
      select:'id,order_number,customer_name,created_at,platforms(name)',
      in:{id:orderIds},noCompanyFilter:true
    });
    const orderMap={};
    (orderDetails||[]).forEach(o=>{orderMap[o.id]=o;});

    const rows=(items||[]).map(i=>{
      const o=orderMap[i.order_id];
      const direction=i.override_pct<0?'danger':'success';
      return [
        util().sanitize(o?.order_number||'—'),
        util().formatDate(o?.created_at),
        util().sanitize(o?.customer_name||'—'),
        util().sanitize(o?.platforms?.name||'—'),
        util().sanitize(i.product_name||'—'),
        util().sanitize(i.sku||'—'),
        i.quantity,
        util().formatCurrency(i.standard_price),
        util().formatCurrency(i.unit_price),
        `<span style="color:var(--ims-${direction});font-weight:600">${i.override_pct>0?'+':''}${(i.override_pct||0).toFixed(1)}%</span>`,
        util().formatCurrency((i.standard_price-i.unit_price)*i.quantity),
        util().sanitize(i.override_reason||'—')
      ];
    });

    const totalVariance=(items||[]).reduce((s,i)=>s+((i.standard_price-i.unit_price)*(i.quantity||1)),0);
    body.innerHTML+=`
      <div class="ims__alert ims__alert--${totalVariance<0?'danger':'warning'}" style="margin-top:14px;margin-bottom:14px">
        <i class="ti ti-alert-triangle"></i>
        <span><strong>${rows.length} price override(s)</strong> across ${orderIds.length} order(s) in this period.
        Total revenue variance from standard prices: <strong>${util().formatCurrency(Math.abs(totalVariance))}</strong>
        ${totalVariance<0?' below standard (discounts given)':' above standard (premiums charged)'}</span>
      </div>`+
      tbl(['Order #','Date','Customer','Platform','Product','SKU','Qty','Standard price','Charged price','Variance %','Revenue impact','Reason'],rows);
  }

  // ─── PRINT / EXPORT ─────────────────────────────────────────────
  function printCurrentReport(){
    const body=document.getElementById('ims-modal-body');
    if(!body)return;
    util().print(body.innerHTML,_reportTitle);
  }

  function exportCurrentCSV(){
    if(!_reportHeaders.length){ui().toast('No data to export','warning');return;}
    const plainRows=_reportData.map(row=>row.map(cell=>{
      const tmp=document.createElement('div');
      tmp.innerHTML=String(cell||'');
      return tmp.textContent||tmp.innerText||'';
    }));
    util().exportCSV(_reportHeaders,plainRows,_reportTitle.toLowerCase().replace(/\s/g,'_'));
  }

  window.addEventListener('ims:panel',e=>{if(e.detail.panel==='reports')load();});
  window.IMS_REPORTS={load,filterReports,runReport,refreshCurrentReport,loadCustomerStatement,loadSupplierStatement,printCurrentReport,exportCurrentCSV};
})();